const galleryImages = [
  {
    src: "/images/design/3d-model.webp",
    label: "3D Engineering Design",
    span: "col-span-1 row-span-2",
  },
  {
    src: "/images/hvac/ahu.webp",
    label: "HVAC Air Handling Units",
    span: "col-span-1 row-span-1",
  },
  {
    src: "/images/food/mixing-tanks.webp",
    label: "Food Processing Plant",
    span: "col-span-1 row-span-1",
  },
  {
    src: "/images/machinery/compressors.webp",
    label: "Industrial Machinery",
    span: "col-span-1 row-span-1",
  },
  {
    src: "/images/kitchen/cooking-range.webp",
    label: "Commercial Kitchen",
    span: "col-span-1 row-span-1",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      className="py-24 relative overflow-hidden"
      style={{
        background: "linear-gradient(150deg, #d8f8f7 0%, #c8f2ef 35%, #d6f5ed 65%, #e4faf5 100%)",
      }}
    >
      {/* Decorative glows */}
      <div className="absolute top-0 left-0 w-96 h-96 rounded-full pointer-events-none opacity-40"
        style={{ background: "radial-gradient(circle, rgba(6,182,212,0.30) 0%, transparent 70%)", transform: "translate(-30%,-30%)" }} />
      <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full pointer-events-none opacity-30"
        style={{ background: "radial-gradient(circle, rgba(20,184,166,0.30) 0%, transparent 70%)", transform: "translate(25%,25%)" }} />

      <div className="relative max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-teal-100 text-teal-600 text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full">
            Our Portfolio
          </span>
          <h2 className="text-teal-900 text-4xl md:text-5xl font-extrabold uppercase tracking-tight mt-4">
            Project Gallery
          </h2>
          <p className="text-teal-700/70 text-sm mt-3 max-w-xl mx-auto">
            A snapshot of our completed engineering projects across Kenya — from HVAC to commercial kitchens and beyond.
          </p>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 auto-rows-[220px]">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className={`relative overflow-hidden rounded-xl group cursor-pointer border-2 border-white/80 ${img.span}`}
              style={{ boxShadow: "0 4px 20px rgba(20,184,166,0.12)" }}
            >
              <img
                src={img.src}
                alt={img.label}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Label overlay on hover */}
              <div className="absolute inset-0 bg-teal-900/0 group-hover:bg-teal-900/55 transition-all duration-300 flex items-end p-4">
                <span className="text-white text-sm font-semibold opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0 bg-teal-600/80 px-3 py-1 rounded-md backdrop-blur-sm">
                  {img.label}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/project-gallery"
            className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold px-8 py-3 rounded-lg uppercase text-sm tracking-wider transition-all duration-200 cursor-pointer"
          >
            <i className="ri-external-link-line"></i>
            View Full Gallery
          </a>
        </div>
      </div>
    </section>
  );
}
